WatchSumo.DailyAvailability = class DailyAvailability extends WatchSumo.Graph {
  render() {
    return Morris.Line({
      element: this.element,
      data: this.data,
      xkey: 'date',
      ykeys: ['percentage'],
      labels: ['Availability'],
      xLabels: "hour",
      postUnits: "%",
      lineWidth: 1,
      lineColors: ["#5da423"]
    });
  }
};